import { __exports as p } from "../../../../_virtual/trees.es.js";
import { __require as Oe } from "../utils/common.es.js";
var de;
function Be() {
  if (de) return p;
  de = 1;
  var oe = Oe(), ve = 4, z = 0, K = 1, be = 2;
  function x(e) {
    for (var r = e.length; --r >= 0; )
      e[r] = 0;
  }
  var ce = 0, Y = 1, ue = 2, he = 3, pe = 258, N = 29, w = 256, g = w + 1 + N, m = 30, O = 19, j = 2 * g + 1, h = 15, R = 16, xe = 7, k = 256, F = 16, G = 17, U = 18, B = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), D = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), me = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), W = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], ye = 512, u = new Array((g + 2) * 2);
  x(u);
  var E = new Array(m * 2);
  x(E);
  var A = new Array(ye);
  x(A);
  var T = new Array(pe - he + 1);
  x(T);
  var Z = new Array(N);
  x(Z);
  var C = new Array(m);
  x(C);
  function q(e, r, _, a, t) {
    this.static_tree = e, this.extra_bits = r, this.extra_base = _, this.elems = a, this.max_length = t, this.has_stree = e && e.length;
  }
  var J, Q, V;
  function M(e, r) {
    this.dyn_tree = e, this.max_code = 0, this.stat_desc = r;
  }
  function $(e) {
    return e < 256 ? A[e] : A[256 + (e >>> 7)];
  }
  function S(e, r) {
    e.pending_buf[e.pending++] = r & 255, e.pending_buf[e.pending++] = r >>> 8 & 255;
  }
  function v(e, r, _) {
    e.bi_valid > R - _ ? (e.bi_buf |= r << e.bi_valid & 65535, S(e, e.bi_buf), e.bi_buf = r >> R - e.bi_valid, e.bi_valid += _ - R) : (e.bi_buf |= r << e.bi_valid & 65535, e.bi_valid += _);
  }
  function c(e, r, _) {
    v(
      e,
      _[r * 2],
      _[r * 2 + 1]
      /*.Len*/
    );
  }
  function s(e, r) {
    var _ = 0;
    do
      _ |= e & 1, e >>>= 1, _ <<= 1;
    while (--r > 0);
    return _ >>> 1;
  }
  function we(e) {
    e.bi_valid === 16 ? (S(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
  }
  function ge(e, r) {
    var _ = r.dyn_tree, a = r.max_code, t = r.stat_desc.static_tree, i = r.stat_desc.has_stree, n = r.stat_desc.extra_bits, f = r.stat_desc.extra_base, d = r.stat_desc.max_length, l, b, y, o, I, P, L = 0;
    for (o = 0; o <= h; o++)
      e.bl_count[o] = 0;
    for (_[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < j; l++)
      b = e.heap[l], o = _[_[b * 2 + 1] * 2 + 1] + 1, o > d && (o = d, L++), _[b * 2 + 1] = o, !(b > a) && (e.bl_count[o]++, I = 0, b >= f && (I = n[b - f]), P = _[b * 2], e.opt_len += P * (o + I), i && (e.static_len += P * (t[b * 2 + 1] + I)));
    if (L !== 0) {
      do {
        for (o = d - 1; e.bl_count[o] === 0; )
          o--;
        e.bl_count[o]--, e.bl_count[o + 1] += 2, e.bl_count[d]--, L -= 2;
      } while (L > 0);
      for (o = d; o !== 0; o--)
        for (b = e.bl_count[o]; b !== 0; )
          y = e.heap[--l], !(y > a) && (_[y * 2 + 1] !== o && (e.opt_len += (o - _[y * 2 + 1]) * _[y * 2], _[y * 2 + 1] = o), b--);
    }
  }
  function ee(e, r, _) {
    var a = new Array(h + 1), t = 0, i, n;
    for (i = 1; i <= h; i++)
      a[i] = t = t + _[i - 1] << 1;
    for (n = 0; n <= r; n++) {
      var f = e[n * 2 + 1];
      f !== 0 && (e[n * 2] = s(a[f]++, f));
    }
  }
  function Ee() {
    var e, r, _, a, t, i = new Array(h + 1);
    for (_ = 0, a = 0; a < N - 1; a++)
      for (Z[a] = _, e = 0; e < 1 << B[a]; e++)
        T[_++] = a;
    for (T[_ - 1] = a, t = 0, a = 0; a < 16; a++)
      for (C[a] = t, e = 0; e < 1 << D[a]; e++)
        A[t++] = a;
    for (t >>= 7; a < m; a++)
      for (C[a] = t << 7, e = 0; e < 1 << D[a] - 7; e++)
        A[256 + t++] = a;
    for (r = 0; r <= h; r++)
      i[r] = 0;
    for (e = 0; e <= 143; )
      u[e * 2 + 1] = 8, e++, i[8]++;
    for (; e <= 255; )
      u[e * 2 + 1] = 9, e++, i[9]++;
    for (; e <= 279; )
      u[e * 2 + 1] = 7, e++, i[7]++;
    for (; e <= 287; )
      u[e * 2 + 1] = 8, e++, i[8]++;
    for (ee(u, g + 1, i), e = 0; e < m; e++)
      E[e * 2 + 1] = 5, E[e * 2] = s(e, 5);
    J = new q(u, B, w + 1, g, h), Q = new q(E, D, 0, m, h), V = new q(new Array(0), me, 0, O, xe);
  }
  function re(e) {
    var r;
    for (r = 0; r < g; r++)
      e.dyn_ltree[r * 2] = 0;
    for (r = 0; r < m; r++)
      e.dyn_dtree[r * 2] = 0;
    for (r = 0; r < O; r++)
      e.bl_tree[r * 2] = 0;
    e.dyn_ltree[k * 2] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
  }
  function _e(e) {
    e.bi_valid > 8 ? S(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
  }
  function Ae(e, r, _, a) {
    _e(e), S(e, _), S(e, ~_), oe.arraySet(e.pending_buf, e.window, r, _, e.pending), e.pending += _;
  }
  function ae(e, r, _, a) {
    var t = r * 2, i = _ * 2;
    return e[t] < e[i] || e[t] === e[i] && a[r] <= a[_];
  }
  function X(e, r, _) {
    for (var a = e.heap[_], t = _ << 1; t <= e.heap_len && (t < e.heap_len && ae(r, e.heap[t + 1], e.heap[t], e.depth) && t++, !ae(r, a, e.heap[t], e.depth)); )
      e.heap[_] = e.heap[t], _ = t, t <<= 1;
    e.heap[_] = a;
  }
  function te(e, r, _) {
    var a, t, i = 0, n, f;
    if (e.last_lit !== 0)
      do
        a = e.pending_buf[e.d_buf + i * 2] << 8 | e.pending_buf[e.d_buf + i * 2 + 1], t = e.pending_buf[e.l_buf + i], i++, a === 0 ? c(e, t, r) : (n = T[t], c(e, n + w + 1, r), f = B[n], f !== 0 && (t -= Z[n], v(e, t, f)), a--, n = $(a), c(e, n, _), f = D[n], f !== 0 && (a -= C[n], v(e, a, f)));
      while (i < e.last_lit);
    c(e, k, r);
  }
  function H(e, r) {
    var _ = r.dyn_tree, a = r.stat_desc.static_tree, t = r.stat_desc.has_stree, i = r.stat_desc.elems, n, f, d = -1, l;
    for (e.heap_len = 0, e.heap_max = j, n = 0; n < i; n++)
      _[n * 2] !== 0 ? (e.heap[++e.heap_len] = d = n, e.depth[n] = 0) : _[n * 2 + 1] = 0;
    for (; e.heap_len < 2; )
      l = e.heap[++e.heap_len] = d < 2 ? ++d : 0, _[l * 2] = 1, e.depth[l] = 0, e.opt_len--, t && (e.static_len -= a[l * 2 + 1]);
    for (r.max_code = d, n = e.heap_len >> 1; n >= 1; n--)
      X(e, _, n);
    l = i;
    do
      n = e.heap[
        1
        /*SMALLEST*/
      ], e.heap[
        1
        /*SMALLEST*/
      ] = e.heap[e.heap_len--], X(
        e,
        _,
        1
        /*SMALLEST*/
      ), f = e.heap[
        1
        /*SMALLEST*/
      ], e.heap[--e.heap_max] = n, e.heap[--e.heap_max] = f, _[l * 2] = _[n * 2] + _[f * 2], e.depth[l] = (e.depth[n] >= e.depth[f] ? e.depth[n] : e.depth[f]) + 1, _[n * 2 + 1] = _[f * 2 + 1] = l, e.heap[
        1
        /*SMALLEST*/
      ] = l++, X(
        e,
        _,
        1
        /*SMALLEST*/
      );
    while (e.heap_len >= 2);
    e.heap[--e.heap_max] = e.heap[
      1
      /*SMALLEST*/
    ], ge(e, r), ee(_, d, e.bl_count);
  }
  function ne(e, r, _) {
    var a, t = -1, i, n = r[0 * 2 + 1], f = 0, d = 7, l = 4;
    for (n === 0 && (d = 138, l = 3), r[(_ + 1) * 2 + 1] = 65535, a = 0; a <= _; a++)
      i = n, n = r[(a + 1) * 2 + 1], !(++f < d && i === n) && (f < l ? e.bl_tree[i * 2] += f : i !== 0 ? (i !== t && e.bl_tree[i * 2]++, e.bl_tree[F * 2]++) : f <= 10 ? e.bl_tree[G * 2]++ : e.bl_tree[U * 2]++, f = 0, t = i, n === 0 ? (d = 138, l = 3) : i === n ? (d = 6, l = 3) : (d = 7, l = 4));
  }
  function ie(e, r, _) {
    var a, t = -1, i, n = r[0 * 2 + 1], f = 0, d = 7, l = 4;
    for (n === 0 && (d = 138, l = 3), a = 0; a <= _; a++)
      if (i = n, n = r[(a + 1) * 2 + 1], !(++f < d && i === n)) {
        if (f < l)
          do
            c(e, i, e.bl_tree);
          while (--f !== 0);
        else i !== 0 ? (i !== t && (c(e, i, e.bl_tree), f--), c(e, F, e.bl_tree), v(e, f - 3, 2)) : f <= 10 ? (c(e, G, e.bl_tree), v(e, f - 3, 3)) : (c(e, U, e.bl_tree), v(e, f - 11, 7));
        f = 0, t = i, n === 0 ? (d = 138, l = 3) : i === n ? (d = 6, l = 3) : (d = 7, l = 4);
      }
  }
  function Te(e) {
    var r;
    for (ne(e, e.dyn_ltree, e.l_desc.max_code), ne(e, e.dyn_dtree, e.d_desc.max_code), H(e, e.bl_desc), r = O - 1; r >= 3 && e.bl_tree[W[r] * 2 + 1] === 0; r--)
      ;
    return e.opt_len += 3 * (r + 1) + 5 + 5 + 4, r;
  }
  function Se(e, r, _, a) {
    var t;
    for (v(e, r - 257, 5), v(e, _ - 1, 5), v(e, a - 4, 4), t = 0; t < a; t++)
      v(e, e.bl_tree[W[t] * 2 + 1], 3);
    ie(e, e.dyn_ltree, r - 1), ie(e, e.dyn_dtree, _ - 1);
  }
  function De(e) {
    var r = 4093624447, _;
    for (_ = 0; _ <= 31; _++, r >>>= 1)
      if (r & 1 && e.dyn_ltree[_ * 2] !== 0)
        return z;
    if (e.dyn_ltree[9 * 2] !== 0 || e.dyn_ltree[10 * 2] !== 0 || e.dyn_ltree[13 * 2] !== 0)
      return K;
    for (_ = 32; _ < w; _++)
      if (e.dyn_ltree[_ * 2] !== 0)
        return K;
    return z;
  }
  var fe = !1;
  function Ce(e) {
    fe || (Ee(), fe = !0), e.l_desc = new M(e.dyn_ltree, J), e.d_desc = new M(e.dyn_dtree, Q), e.bl_desc = new M(e.bl_tree, V), e.bi_buf = 0, e.bi_valid = 0, re(e);
  }
  function le(e, r, _, a) {
    v(e, (ce << 1) + (a ? 1 : 0), 3), Ae(e, r, _);
  }
  function Ie(e) {
    v(e, Y << 1, 3), c(e, k, u), we(e);
  }
  function Le(e, r, _, a) {
    var t, i, n = 0;
    e.level > 0 ? (e.strm.data_type === be && (e.strm.data_type = De(e)), H(e, e.l_desc), H(e, e.d_desc), n = Te(e), t = e.opt_len + 3 + 7 >>> 3, i = e.static_len + 3 + 7 >>> 3, i <= t && (t = i)) : t = i = _ + 5, _ + 4 <= t && r !== -1 ? le(e, r, _, a) : e.strategy === ve || i === t ? (v(e, (Y << 1) + (a ? 1 : 0), 3), te(e, u, E)) : (v(e, (ue << 1) + (a ? 1 : 0), 3), Se(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, n + 1), te(e, e.dyn_ltree, e.dyn_dtree)), re(e), a && _e(e);
  }
  function Ne(e, r, _) {
    return e.pending_buf[e.d_buf + e.last_lit * 2] = r >>> 8 & 255, e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = r & 255, e.pending_buf[e.l_buf + e.last_lit] = _ & 255, e.last_lit++, r === 0 ? e.dyn_ltree[_ * 2]++ : (e.matches++, r--, e.dyn_ltree[(T[_] + w + 1) * 2]++, e.dyn_dtree[$(r) * 2]++), e.last_lit === e.lit_bufsize - 1;
  }
  return p._tr_init = Ce, p._tr_stored_block = le, p._tr_flush_block = Le, p._tr_tally = Ne, p._tr_align = Ie, p;
}
export {
  Be as __require
};
//# sourceMappingURL=trees.es.js.map
